import { Font, Page, StyleSheet, Text, View, Image } from '@react-pdf/renderer';
import React, { Fragment } from 'react';
import { BANK_DETAILS, EMPTY_VALUE, GST_NUMBER, PAN_NUMBER, PDF_ALL_MARGIN, PDF_LEFT_MARGIN, PDF_RIGHT_MARGIN } from '../../constants';
import { convertAmountToWords, displayFormattedDate, formatCurrency, formatDate, getClientConfig, isEmpty } from '../../generalFunctions';
import Signature from './common/Signature';
import font from "../../assests/fonts/ARLRDBD.ttf";
import logo from "../../assests/images/LuktukeLogo.png";

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        padding: 10
    },
    detailColumn: {
        flexDirection: 'column',
        flexGrow: 15,
    },
    linkColumn: {
        flexDirection: 'column',
        flexGrow: 2,
        alignSelf: 'flex-end',
        justifySelf: 'flex-end',
    },
    title: {
        fontSize: 16,
        fontWeight: "bold",
        borderStyle: "solid",
        borderColor: "black",
        borderWidth: 2,
        maxWidth: 200,
        textAlign: "left",
        padding: 10,
        marginBottom: 1
    },
    subtitle: {
        flexDirection: "column",
        flexGrow: 2,
        fontSize: 7,
        marginBottom: 1
    },
    image: {
        width: 130,
        height: 80
    },
    ronumber: {
        flexDirection: "column",
        //flexGrow: 1,
        fontSize: 12,
        fontWeight: "bold",
        //marginLeft: 3,
    }
});

Font.register({
    family: "ARLRDBD",
    format: "truetype",
    src: font
});

const displayMultipleDates = (dateOfInsertion) => {
    let dates = dateOfInsertion.split(",")
    let uniq = [...new Set(dates)];
    return uniq.toString().replace(/,/g, ", ");
};

const getTotalDays = (dateOfInsertion) => {
    let dates = dateOfInsertion?.split(",")
    let uniq = [...new Set(dates)];
    return uniq.length;
};

const InvoicePdf = (props) => {
    let totalHeight = 180;
    props.data.roData?.forEach((element, index) => {
        element.sizeCms = (element.width && element.height) ? element.width + " * " + element.height : "";
        element.totalDays = element.totalDays ? element.totalDays : getTotalDays(element.dateOfInsertion);
        totalHeight = index < props.data.roData.length - 1 ? totalHeight - (element.dateOfInsertion ? element.dateOfInsertion?.split(",").length * 15 : 15) : totalHeight;
        element.height = index < props.data.roData.length - 1 ? (element.dateOfInsertion ? element.dateOfInsertion?.split(",").length * 15 : 15) : totalHeight;
        element.rate = !isEmpty(element.rate) ? formatCurrency(element.rate) : (element.roAmount && element.totalDays ? formatCurrency(element.roAmount / element.totalDays) : "");
        element.roAmount = !isEmpty(element.roAmount) ? formatCurrency(element.roAmount) : element.roAmount;
        element.dateOfInsertion = element.dateOfInsertion ?
            (element.dateOfInsertion.split(",").length > 1 ? displayMultipleDates(element.dateOfInsertion) :
                element.dateOfInsertion.includes("T") ? displayFormattedDate(element.dateOfInsertion) :
                    (element.dateOfInsertion)) : element.date;
    });
    const tableData = {
        columnName: props.isClassified ? ["Publication", "Release Date", "Page No", "RO For", "Rate/Day", "Total Days", "Amount"] :
            ["Publication", "Release Date", "Page No", "Size          (W X H)", "Rate/Day", "Total Days", "Amount"],
        column: props.isClassified ? ["publication", "dateOfInsertion", "pageNumber", "client", "rate", "totalDays", "roAmount"] :
            ["publication", "dateOfInsertion", "pageNumber", "sizeCms", "rate", "totalDays", "roAmount"],
        width: [29, 15, 8, 12, 13, 8, 15],
        data: props.data.roData
    }

    const { account } = getClientConfig();
    const selectedAccount = account.find(a => a.id === props.data.billForId);
    const checkBillForIsSame = () => {
        if (props.data.billFor !== props.data.roFor) {
            const roFor = !isEmpty(props.data.roFor) ? (" (" + props.data.roFor + ")") : EMPTY_VALUE;
            return roFor;
        }
    }

    return (
        <Page style={{ paddingLeft: PDF_LEFT_MARGIN, margin: PDF_ALL_MARGIN, paddingRight: PDF_RIGHT_MARGIN }} id={props.data.id} size="A4">
            <View style={styles.container}>
                <View style={styles.detailColumn}>
                    <View style={styles.title}>
                        <Text style={{ alignSelf: "center", fontFamily: "ARLRDBD", letterSpacing: 5 }} >{"I N V O I C E"}</Text>
                    </View>
                    <View style={{ flexDirection: "row", marginTop: 2 }}>
                        <Text style={styles.ronumber}>No : {props.data.id}</Text>
                        <Text style={{
                            //flexDirection: "column",
                            flexGrow: 1.5,
                            fontSize: 12,
                            //marginBottom: 5,
                            marginLeft: 45

                        }}>Date : {formatDate(props.data.invoiceDate)}</Text>
                    </View>
                </View>
                <View style={styles.linkColumn}>
                    <Image
                        src={logo}
                        style={styles.image}
                    />
                </View>
            </View>

            <View style={{ flexDirection: "row", padding: 10, marginBottom: 1 }}>
                <View style={{ flexDirection: "column", flexGrow: 1, width: 160 }}>
                    <Text style={{
                        fontSize: 12,
                        flexDirection: "row",
                        marginRight: 20,
                        flexGrow: 1,
                        lineHeight: 2,
                        fontWeight: "bold",
                    }}>
                        {props.data.billFor}
                    </Text>
                    {!isEmpty(selectedAccount.address) && <Text style={{
                        fontSize: 10,
                        flexDirection: "row",
                        marginRight: 20,
                        flexGrow: 1,
                        lineHeight: 2,

                    }}>
                        {selectedAccount.address}
                    </Text>}
                </View>
                <View style={{ flexDirection: "column", flexGrow: 1 }}>
                    <Text style={{
                        fontSize: 10,
                        flexDirection: "row",
                        marginRight: 20,
                        flexGrow: 1,
                        lineHeight: 2,

                    }}>
                        {"GSTIN: " + selectedAccount.gstNumber}
                    </Text>
                    {<Text style={{
                        fontSize: 10,
                        flexDirection: "row",
                        marginRight: 20,
                        flexGrow: 1,
                        lineHeight: 2,

                    }}>
                        {!isEmpty(props.data.roData[0].captionName) && "Caption : " + props.data.roData[0].captionName}
                        {checkBillForIsSame()}
                    </Text>}
                </View>
            </View>
            <Fragment>
                <View style={{ flexDirection: 'row', textAlign: "center", alignSelf: "flex-start", marginRight: 22, border: 1, borderBottom: 0 }}>
                    {tableData["columnName"].map((c, index) => <Text style={{
                        width: `${tableData["width"][index]}%`, padding: 8, fontSize: 10, borderRight: index < 6 ? 1 : null,
                    }}>{c}</Text>)}
                </View>
                <View style={{ marginRight: 22, border: 1, minHeight: 180 }}>
                    {tableData["data"].map((rowData, index) => <>

                        <View style={{ flexDirection: 'row', alignSelf: "flex-start" }}>
                            {tableData["column"].map((c, index) =>
                                <Text style={{
                                    width: `${tableData["width"][index]}%`, fontSize: 10, borderRight: index < 6 ? 1 : null, paddingTop: 5, minHeight: rowData["height"], textAlign: index === 6 ? "right" : "center", paddingRight: index === 6 ? 10 : 0,

                                }}>{rowData[c]}</Text>
                            )}
                        </View>
                    </>)}
                </View>

            </Fragment>
            <View style={{ flexDirection: "row", marginBottom: 5, marginRight: 12, marginTop: 5 }}>
                <View style={{ flexDirection: "column", flexGrow: props.isClassified ? 0.3 : 0.4, alignSelf: "flex-start", border: 1 }}>
                    <Text style={{
                        fontSize: 10,
                        flexDirection: "row",
                        marginBottom: 20,
                        flexGrow: 1,
                        alignSelf: "flex-start",
                        paddingLeft: 15
                    }}></Text>
                    <Text style={{
                        fontSize: 12,
                        flexDirection: "row",
                        marginBottom: 5,
                        flexGrow: 1,
                        alignSelf: "flex-start",
                        paddingLeft: 15,
                        fontWeight: "bold",

                    }}>Bank Details :</Text>
                    <Text style={{
                        fontSize: 10,
                        flexDirection: "row",
                        marginBottom: 3,
                        flexGrow: 1,
                        alignSelf: "flex-start",
                        paddingLeft: 15,

                    }}>{BANK_DETAILS.bank}</Text>
                    <Text style={{
                        fontSize: 10,
                        flexDirection: "row",
                        marginBottom: 3,
                        flexGrow: 1,
                        alignSelf: "flex-start",
                        paddingLeft: 15,

                    }}>Account Number : {BANK_DETAILS.accNo}</Text>
                    <Text style={{
                        fontSize: 10,
                        flexDirection: "row",
                        marginBottom: 3,
                        flexGrow: 1,
                        alignSelf: "flex-start",
                        paddingLeft: 15,

                    }}>IFSC : {BANK_DETAILS.ifsc}</Text>
                    <Text style={{
                        fontSize: 10,
                        flexDirection: "row",
                        marginBottom: 3,
                        flexGrow: 1,
                        alignSelf: "flex-start",
                        paddingLeft: 15,

                    }}>Branch : {BANK_DETAILS.branch}</Text>
                    <Text style={{
                        fontSize: 10,
                        flexDirection: "row",
                        marginBottom: 3,
                        flexGrow: 1,
                        alignSelf: "flex-start",
                        paddingLeft: 15,

                    }}>PAN : {PAN_NUMBER}</Text>
                    <Text style={{
                        fontSize: 10,
                        flexDirection: "row",
                        marginBottom: 3,
                        flexGrow: 1,
                        alignSelf: "flex-start",
                        paddingLeft: 15,

                    }}>GSTIN : {GST_NUMBER}</Text>
                    <View style={{ flexDirection: "row", borderBottomWidth: 1 }}></View>
                    <Text style={{
                        fontSize: 10,
                        flexDirection: "row",
                        alignSelf: "flex-start",
                        paddingLeft: 15,
                        marginBottom: 28,
                        paddingTop: 5,
                        flex: 1,
                        width: 250
                    }}>Rupees In Words : {convertAmountToWords(props.data.finalBillAmount)}only</Text>
                </View>
                <View style={{ flexDirection: "column", flexGrow: 2, borderTop: 1, borderBottom: 1 }}>
                    <View style={{ flexDirection: "row", alignItems: "flex-start", paddingLeft: 15, paddingTop: 5 }}>
                        <Text style={{
                            fontSize: 10,
                            marginBottom: 3,
                            flexDirection: "column",
                            flexGrow: 3,
                            fontWeight: "bold",

                        }}>Total :</Text>
                    </View>
                    <View style={{ flexDirection: "row", borderBottomWidth: 1 }}></View>
                    <View style={{ flexDirection: "row", paddingLeft: 15, alignItems: "flex-start", paddingTop: 5 }}>
                        <Text style={{
                            fontSize: 10,
                            marginBottom: 3,
                            flexDirection: "column",
                            flexGrow: 2,
                            fontWeight: "bold",

                        }}>Less : ( {props.data.commission + "%"} )</Text>
                    </View>
                    <View style={{ flexDirection: "row", borderBottomWidth: 1 }}></View>
                    <View style={{ flexDirection: "row", paddingLeft: 15, paddingTop: 5 }}>
                        <Text style={{
                            fontSize: 10,
                            marginBottom: 3,
                            flexDirection: "column",
                            flexGrow: 2,
                            alignSelf: "flex-start",
                            fontWeight: "bold",

                        }}>Other Charges :</Text>
                    </View>
                    <View style={{ flexDirection: "row", borderBottomWidth: 1 }}></View>
                    <View style={{ flexDirection: "row", paddingLeft: 15, paddingTop: 5 }}>
                        <Text style={{
                            fontSize: 10,
                            marginBottom: 3,
                            flexDirection: "column",
                            flexGrow: 2,
                            alignSelf: "flex-start",
                            fontWeight: "bold",

                        }}>Taxable Amount :</Text>
                    </View>
                    <View style={{ flexDirection: "row", borderBottomWidth: 1 }}></View>
                    {!props.data.igst > 0 && <>
                        <View style={{ flexDirection: "row", paddingLeft: 15, paddingTop: 5 }}>
                            <Text style={{
                                fontSize: 10,
                                marginBottom: 3,
                                flexDirection: "column",
                                flexGrow: 2,
                                alignSelf: "flex-start",
                                fontWeight: "bold",

                            }}>CGST : {props.data.cgstRate}%</Text>
                        </View></>} {!props.data.igst > 0 && <>
                            <View style={{ flexDirection: "row", paddingLeft: 15, paddingTop: 5 }}>
                                <Text style={{
                                    fontSize: 10,
                                    marginBottom: 3,
                                    flexDirection: "column",
                                    flexGrow: 2,
                                    alignSelf: "flex-start",
                                    fontWeight: "bold",

                                }}>SGST : {props.data.sgstRate}%</Text>
                            </View><View style={{ flexDirection: "row", borderBottomWidth: 1 }}></View></>}

                    {props.data.igstRate > 0 && <><View style={{ flexDirection: "row", paddingLeft: 15, paddingTop: 5 }}>
                        <Text style={{
                            fontSize: 10,
                            marginBottom: 3,
                            flexDirection: "column",
                            flexGrow: 2,
                            alignSelf: "flex-start",
                            fontWeight: "bold",
                        }}>IGST : {props.data.igstRate}%</Text>
                    </View><View style={{ flexDirection: "row", borderBottomWidth: 1 }}></View></>}
                    <View style={{ flexDirection: "row", paddingLeft: 15, paddingTop: 5 }}>
                        <Text style={{
                            fontSize: 10,
                            marginBottom: 3,
                            flexDirection: "column",
                            flexGrow: 2,
                            alignSelf: "flex-start",
                            fontWeight: "bold",
                        }}>Round Off :</Text>
                    </View>
                    <View style={{ flexDirection: "row", borderBottomWidth: 1 }}></View>
                    <View style={{ flexDirection: "row", paddingLeft: 15, paddingTop: 5 }}>
                        <Text style={{
                            fontSize: 10,
                            marginBottom: 1,
                            flexDirection: "column",
                            flexGrow: 2,
                            alignSelf: "flex-start",
                            fontWeight: "bold",

                        }}>Net Bill :</Text>
                    </View>
                </View>
                <View style={{ flexDirection: "column", flexGrow: props.isClassified ? 0.7 : 0.4, marginRight: 10, border: 1 }}>
                    <View style={{ flexDirection: "row", paddingTop: 5, marginRight: 10, alignSelf: "flex-end" }}>
                        <Text style={{
                            fontSize: 10,
                            flexDirection: "column",
                            marginBottom: 3,
                            flexGrow: 1,

                        }}>{formatCurrency(props.data.total)}</Text>
                    </View>
                    <View style={{ flexDirection: "row", borderBottomWidth: 1 }}></View>
                    <View style={{ flexDirection: "row", paddingTop: 5, marginRight: 10, alignSelf: "flex-end" }}>
                        <Text style={{
                            fontSize: 10,
                            flexDirection: "column",
                            marginBottom: 3,
                            flexGrow: 1,

                        }}>{formatCurrency(props.data.commissionInRs)}</Text>
                    </View>
                    <View style={{ flexDirection: "row", borderBottomWidth: 1 }}></View>
                    <View style={{ flexDirection: "row", marginRight: 10, paddingTop: 5, alignSelf: "flex-end" }}>
                        <Text style={{
                            fontSize: 10,
                            flexDirection: "column",
                            marginBottom: 3,
                            flexGrow: 1,

                        }}>{formatCurrency(props.data.otherChargesInRs)}</Text>
                    </View>
                    <View style={{ flexDirection: "row", borderBottomWidth: 1 }}></View>
                    <View style={{ flexDirection: "row", marginRight: 10, paddingTop: 5, alignSelf: "flex-end" }}>
                        <Text style={{
                            fontSize: 10,
                            flexDirection: "column",
                            marginBottom: 3,
                            flexGrow: 1,
                            fontWeight: "bold",

                        }}>{formatCurrency(props.data.taxable)}</Text>
                    </View>
                    <View style={{ flexDirection: "row", borderBottomWidth: 1 }}></View>
                    {!props.data.igst > 0 && <>
                        <View style={{ flexDirection: "row", marginRight: 10, paddingTop: 5, alignSelf: "flex-end" }}>
                            <Text style={{
                                fontSize: 10,
                                flexDirection: "column",
                                marginBottom: 3,
                                flexGrow: 1,

                            }}>{formatCurrency(props.data.cgst)}</Text>
                        </View>
                        <View style={{ flexDirection: "row", marginRight: 10, paddingTop: 5, alignSelf: "flex-end" }}>
                            <Text style={{
                                fontSize: 10,
                                flexDirection: "column",
                                marginBottom: 3,
                                flexGrow: 1,

                            }}>{formatCurrency(props.data.sgst)}</Text>
                        </View>
                        <View style={{ flexDirection: "row", borderBottomWidth: 1 }}></View>
                    </>}

                    {props.data.igstRate > 0 && <><View style={{ flexDirection: "row", marginRight: 10, paddingTop: 5, alignSelf: "flex-end" }}>
                        <Text style={{
                            fontSize: 10,
                            flexDirection: "column",
                            marginBottom: 3,
                            flexGrow: 1,

                        }}>{formatCurrency(props.data.igst)}</Text>
                    </View><View style={{ flexDirection: "row", borderBottomWidth: 1 }}></View></>}
                    <View style={{ flexDirection: "row", marginRight: 10, paddingTop: 5, alignSelf: "flex-end" }}>
                        <Text style={{
                            fontSize: 10,
                            flexDirection: "column",
                            marginBottom: 3,
                            flexGrow: 1,

                        }}>{formatCurrency(props.data.roundOff)}</Text>
                    </View>
                    <View style={{ flexDirection: "row", borderBottomWidth: 1 }}></View>
                    <View style={{ flexDirection: "row", marginRight: 10, paddingTop: 5, alignSelf: "flex-end" }}>
                        <Text style={{
                            fontSize: 10,
                            flexDirection: "column",
                            marginBottom: 1,
                            flexGrow: 1,
                            fontWeight: "bold",

                        }}>{formatCurrency(props.data.finalBillAmount)}</Text>
                    </View>
                </View>
            </View>

            <Signature />
        </Page>
    );
}

export default InvoicePdf;